import api from './api';

const extractData = (data) => {
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  return data;
};

const placeProfessionalsService = {
  // Retorna todos os profissionais de um local
  // GET /api/places/{placeId}/professionals
  getByPlaceId: async (placeId) => {
    const response = await api.get(`/places/${placeId}/professionals`);
    return extractData(response.data);
  },

  // Retorna os profissionais disponíveis para adicionar ao local
  // GET /api/places/{placeId}/professionals/available
  getAvailableForPlace: async (placeId) => {
    const response = await api.get(`/places/${placeId}/professionals/available`);
    return extractData(response.data);
  },

  // Buscar por ID
  // GET /api/places/{placeId}/professionals/{id}
  getById: async (placeId, id) => {
    const response = await api.get(`/places/${placeId}/professionals/${id}`);
    return extractData(response.data);
  },

  // Adicionar profissional ao local
  // POST /api/places/{placeId}/professionals
  // Body: { professionalId }
  create: async (placeId, data) => {
    const response = await api.post(`/places/${placeId}/professionals`, data);
    return extractData(response.data);
  },

  // Atualizar PlaceProfessional
  // PUT /api/places/{placeId}/professionals/{id}
  update: async (placeId, id, data) => {
    const response = await api.put(`/places/${placeId}/professionals/${id}`, data);
    return extractData(response.data);
  },

  // Remover profissional do local
  // DELETE /api/places/{placeId}/professionals/{id}
  // ✅ Validação happens in API (isInUseAsync)
  // Se houver erro (400), a exceção vai ser lançada pelo axios
  // Quem chama trata o erro
  delete: async (placeId, id) => {
    await api.delete(`/places/${placeId}/professionals/${id}`);
    // Se chegou aqui, foi sucesso (204 No Content)
  },
};

export default placeProfessionalsService;
